export default "__VITE_ASSET___I75e91G__"